import Cookies from "js-cookie";

const MenuAccess = (menuItems) => {
    if(Cookies.get("userid")) {
        const usermenuitems = JSON.parse(Cookies.get("menu_items") || "[]");
        if (usermenuitems == null) {
            // null or undefined
            return false;
        }
        if (!usermenuitems.hasOwnProperty(menuItems)) {
            return false;
        }
        return usermenuitems[menuItems];
    } else {
        return false;
    }
};
export default MenuAccess;
